(() => {
  const init = (root) => {
    root.querySelectorAll('.gf-faq').forEach((faq) => {
      if (faq.dataset.ready) return;
      faq.dataset.ready = 'true';
      const search = faq.querySelector('[data-faq-search]');
      const status = faq.querySelector('[data-faq-status]');
      const items = [...faq.querySelectorAll('[data-faq-item]')];
      faq.querySelector('.gf-faq__search').hidden = false;
      const normalize = (value) => value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
      search.addEventListener('input', () => {
        const terms = normalize(search.value).trim().split(/\s+/).filter(Boolean);
        let count = 0;
        items.forEach((item) => {
          const matches = terms.every((term) => normalize(item.textContent).includes(term));
          item.hidden = !matches;
          if (matches) count += 1;
        });
        faq.querySelectorAll('[data-faq-group]').forEach((group) => {
          group.hidden = ![...group.querySelectorAll('[data-faq-item]')].some((item) => !item.hidden);
        });
        status.textContent = terms.length ? (count ? `${count} ${status.dataset.resultLabel}` : status.dataset.emptyLabel) : '';
      });
      faq.querySelectorAll('.gf-faq__topics a').forEach((link) => link.addEventListener('click', () => {
        search.value = '';
        search.dispatchEvent(new Event('input'));
      }));
    });
  };
  init(document);
  if (!window.gfFaqEventsBound) {
    document.addEventListener('shopify:section:load', () => init(document));
    window.gfFaqEventsBound = true;
  }
})();
